import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('revTrakAdmin', [booksMenu])
  .controller('revTrakController', revTrakController)
  .name;
  
/*******************************************************************************
 * Controller: revTrakController
 *
 * Controller for the organization info and payment processors.
 *******************************************************************************/
/* @ngInject */ function revTrakController($scope, $q, BooksSvc, BusyScreen, Alert) {
  /*----------------------------------------------------*/
  /* Set the store type for retrieving and saving data. */
  /*----------------------------------------------------*/
  $scope.storeType = 'RevTrak';

  /*****************************************************************************
   * save
   *
   * Called on the Save Changes button. Saves the items.
   *****************************************************************************/
  $scope.save = function () {
    Alert.clear();
    BusyScreen.setBusy(true);

    BooksSvc.saveStoreItems($scope.storeType, $scope.webStoreItems).then(
      function (resp) {
        BusyScreen.setBusy(false);
        Alert.success('Items have been saved');
      }
    );
  };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  $q.all({
    products: BooksSvc.getProductList(true, false, false, false),
    storeItems: BooksSvc.getStoreItems($scope.storeType)
  }).then(function (resolve) {
    $scope.products = resolve.products.data;
    $scope.webStoreItems = resolve.storeItems.data;
    BusyScreen.setBusy(false);
  });
}